export const isAuthenticated = () => {
    return localStorage.getItem("authUserOptica") !== null
}

export const logout = () => localStorage.removeItem("authUserOptica")
